import { motion } from 'framer-motion';
import { styles } from '../styles';
import { useInView } from 'react-intersection-observer';
import React from 'react';

function Videofeatures() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });
  return (
    <div
      ref={ref}
      className="min-h-screen flex flex-col justify-start text-center items-center pb-4 mt-[24px] overflow-hidden"
    >
      {inView && (
        <React.Fragment>
          {/* for xl screen */}
          <div className="w-[80%] xxl:w-[90%] min-h-screen flex flex-row max-xl:hidden justify-center items-center">
            <motion.div
              initial={{ x: '-100vw' }}
              animate={{ x: 0 }}
              transition={{ stiffness: 100, delay: 1, type: 'slide' }}
              className="h-[calc(100vh-130px)] min-h-[650px] w-[40%] flex flex-col justify-around items-center "
            >
              <span className="w-[95%] justify-start p-8 xxl:p-12 h-[65%] border border-solid border-black black-gradient shadow shadow-white/50 rounded-3xl flex flex-col">
                <span className="w-[90%] font-semibold text-white text-left text-[2.5rem] leading-[3rem] pt-0 pb-2">
                  Built for stories
                </span>
                <span className="w-[90%] text-white/80 text-left text-lg leading-6 pb-4 pt-2">
                  Our hardware is designed for high quality speaker output
                </span>
                <span className="text-white text-xl xxl:text-3xl xxl:py-10 text-left py-2 font-semibold">
                  Max volume: ~100dB
                </span>
                <img
                  src={
                    'https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1723729319/pixa-pie/features/music_feature.webp'
                  }
                  alt="music"
                  className="w-full object-contain object-center"
                ></img>
              </span>
              <span className="w-[95%] justify-center items-center h-[30%] border border-solid border-black black-gradient shadow shadow-white/50 rounded-3xl flex flex-col">
                <span className="bg-shield-pattern w-full h-[100px] bg-contain bg-no-repeat bg-center"></span>
                <span className="text-white text-center font-semibold text-[2rem] leading-[2.25rem] pt-2 pb-2">
                  Privacy focused
                </span>
              </span>
            </motion.div>
            <motion.div
              initial={{ y: '100vh' }}
              animate={{ y: 0 }}
              transition={{ stiffness: 100, delay: 1, type: 'slide' }}
              className=" h-[calc(100vh-130px)] min-h-[650px] w-[55%] flex flex-col justify-around items-center"
            >
              <span className="w-[95%] justify-center items-center h-[58%] border border-solid border-black shadow-lam rounded-3xl bg-lam-pattern bg-no-repeat bg-cover bg-center  flex flex-col">
                <span className="pb-4 text-white text-xl">Powered by</span>
                <span
                  className={`${styles.goldenText} text-9xl w-[100%] font-bold`}
                >
                  AI
                </span>
                <span className="w-[80%] mt-8 space-x-6 flex flex-row justify-center items-center text-center">
                  <span className="bg-timer-pattern bg-contain bg-no-repeat bg-center h-[52px] w-[52px]"></span>
                  <span className="bg-msg-pattern bg-contain bg-no-repeat bg-center h-[52px] w-[52px]"></span>
                  <span className="bg-music-pattern bg-contain bg-no-repeat bg-center h-[52px] w-[52px]"></span>
                </span>
              </span>
              <span className="w-[95%] justify-center items-center h-[35%] border border-solid border-black black-gradient shadow shadow-white rounded-3xl text-white flex flex-col text-center">
                <span className="w-[90%] font-semibold leading-[3rem] text-[2.5rem]">
                  A true companion for everyone
                </span>
              </span>
            </motion.div>
            <motion.div
              initial={{ x: '100vw' }}
              animate={{ x: 0 }}
              transition={{ stiffness: 100, delay: 1, type: 'slide' }}
              className=" h-[calc(100vh-130px)] min-h-[650px] w-[35%] flex flex-col justify-around items-center "
            >
              <span className="w-[95%] justify-evenly items-center h-[36%] border border-solid border-black black-gradient shadow shadow-white/70 rounded-3xl flex flex-col text-center">
                <span className="flex flex-row justify-center items-center w-[80%]">
                  <span className="rounded-full h-20 bg-cover bg-no-repeat bg-center bg-person-1-pattern w-20"></span>
                  <span className="rounded-full h-20 bg-cover bg-no-repeat bg-center bg-person-2-pattern w-20 -ml-4"></span>
                  <span className="rounded-full h-20 bg-cover bg-no-repeat bg-center bg-person-3-pattern w-20 -ml-4"></span>
                </span>
                <span className="flex flex-col text-center justify-center items-center space-x-1 w-[80%]">
                  <span className="text-white font-semibold text-2xl">
                    Loved by kids
                  </span>
                  <span className="text-white font-semibold text-2xl">
                    and parents
                  </span>
                </span>
              </span>
              <span className="w-[95%] justify-center items-center h-[27%] border border-solid border-black black-gradient shadow shadow-white/70 rounded-3xl flex flex-col">
                <span className="flex justify-center items-center w-[90%] mb-3">
                  <span className="text-white text-3xl font-semibold">
                    Up to
                  </span>
                  <span className="bg-battery-pattern bg-contain bg-no-repeat bg-center h-12 w-[54%] ml-1"></span>
                </span>
                <span className="text-white text-3xl font-semibold w-full flex justify-center items-center text-center">
                  battery everyone
                </span>
              </span>
              <span className="w-[95%] justify-center items-center h-[25%] border border-solid border-black black-gradient shadow shadow-white/70 rounded-3xl flex flex-col">
                <span
                  className={`${styles.goldenText} font-bold text-[2.5rem] leading-[2.75rem]`}
                >
                  Wifi
                </span>
                <span
                  className={`text-white font-semibold text-[2rem] leading-[2.25rem]`}
                >
                  Connectivity
                </span>
              </span>
            </motion.div>
          </div>
          {/* for lg screen */}
          <div className="only-show-on-lg-screen w-[90%] min-h-screen flex flex-row justify-center items-center">
            <motion.div
              initial={{ x: '-100vw' }}
              animate={{ x: 0 }}
              transition={{ stiffness: 100, delay: 0.5, type: 'slide' }}
              className="h-[calc(100vh-130px)] min-h-[650px] w-[40%] flex flex-col justify-around items-center "
            >
              <span className="w-[95%] justify-start p-8 h-[65%] border border-solid border-black black-gradient shadow shadow-white/50 rounded-3xl flex flex-col">
                <span className="w-[90%] font-semibold text-white text-left text-[2.5rem] leading-[3rem] pt-0 pb-2">
                  Built for stories
                </span>
                <span className="w-[90%] text-white/80 text-left text-lg leading-6 pb-4 pt-2">
                  Our hardware is designed for high quality speaker output
                </span>
                <span className="text-white text-2xl text-left pt-2 pb-10 font-semibold">
                  Max volume: ~100dB
                </span>
                <img
                  src={
                    'https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1723729319/pixa-pie/features/music_feature.webp'
                  }
                  alt="music"
                  className="w-full h-[200px] mt-[-20px] object-contain object-center"
                ></img>
              </span>
              <span className="w-[95%] justify-center items-center h-[30%] border border-solid border-black black-gradient shadow shadow-white/50 rounded-3xl flex flex-col">
                <span className="bg-shield-pattern w-full h-[100px] bg-contain bg-no-repeat bg-center"></span>
                <span className="text-white text-center font-semibold text-[2rem] leading-[2.25rem] pt-2 pb-2">
                  Privacy focused
                </span>
              </span>
            </motion.div>
            <motion.div
              initial={{ y: '100vh' }}
              animate={{ y: 0 }}
              transition={{ stiffness: 100, delay: 1, type: 'slide' }}
              className=" h-[calc(100vh-130px)] min-h-[650px] w-[55%] flex flex-col justify-around items-center"
            >
              <span className="w-[95%] justify-center items-center h-[58%] border border-solid border-black shadow-lam rounded-3xl bg-lam-pattern bg-no-repeat bg-cover bg-center  flex flex-col">
                <span className="pb-4 text-white text-xl">Powered by</span>
                <span
                  className={`${styles.goldenText} text-9xl w-[100%] font-bold`}
                >
                  AI
                </span>
                <span className="w-[80%] mt-8 space-x-6 flex flex-row justify-center items-center text-center">
                  <span className="bg-timer-pattern bg-contain bg-no-repeat bg-center h-[52px] w-[52px]"></span>
                  <span className="bg-msg-pattern bg-contain bg-no-repeat bg-center h-[52px] w-[52px]"></span>
                  <span className="bg-music-pattern bg-contain bg-no-repeat bg-center h-[52px] w-[52px]"></span>
                </span>
              </span>
              <span className="w-[95%] justify-center items-center h-[35%] border border-solid border-black black-gradient shadow shadow-white rounded-3xl text-white flex flex-col text-center">
                <span className="w-[90%] font-semibold leading-[3rem] text-[2.5rem]">
                  A true companion for everyone
                </span>
              </span>
            </motion.div>
            <motion.div
              initial={{ x: '100vw' }}
              animate={{ x: 0 }}
              transition={{ stiffness: 100, delay: 1, type: 'slide' }}
              className=" h-[calc(100vh-130px)] min-h-[650px] w-[35%] flex flex-col justify-around items-center "
            >
              <span className="w-[95%] justify-evenly items-center h-[36%] border border-solid border-black black-gradient shadow shadow-white/70 rounded-3xl flex flex-col text-center">
                <span className="flex flex-row justify-center items-center w-[80%]">
                  <span className="rounded-full h-20 bg-cover bg-no-repeat bg-center bg-person-1-pattern w-20"></span>
                  <span className="rounded-full h-20 bg-cover bg-no-repeat bg-center bg-person-2-pattern w-20 -ml-4"></span>
                  <span className="rounded-full h-20 bg-cover bg-no-repeat bg-center bg-person-3-pattern w-20 -ml-4"></span>
                </span>
                <span className="flex flex-col text-center justify-center items-center space-x-1 w-[80%]">
                  <span className="text-white font-semibold text-2xl">
                    Loved by kids
                  </span>
                  <span className="text-white font-semibold text-2xl">
                    and parents
                  </span>
                </span>
              </span>
              <span className="w-[95%] justify-center items-center h-[27%] border border-solid border-black black-gradient shadow shadow-white/70 rounded-3xl flex flex-col">
                <span className="flex justify-center items-center w-[90%] mb-3">
                  <span className="text-white text-3xl font-semibold">
                    Up to
                  </span>
                  <span className="bg-battery-pattern bg-contain bg-no-repeat bg-center h-12 w-[54%] ml-2"></span>
                </span>
                <span className="text-white text-3xl font-semibold w-full flex justify-center items-center text-center">
                  battery everyone
                </span>
              </span>
              <span className="w-[95%] justify-center items-center h-[25%] border border-solid border-black black-gradient shadow shadow-white/70 rounded-3xl flex flex-col">
                <span
                  className={`${styles.goldenText} font-bold text-[2.5rem] leading-[2.75rem]`}
                >
                  Wifi
                </span>
                <span
                  className={`text-white font-semibold text-[2rem] leading-[2.25rem]`}
                >
                  Connectivity
                </span>
              </span>
            </motion.div>
          </div>
          {/* for md screen */}
          <div className="only-show-on-md-screen w-[80%] min-h-screen flex flex-col justify-center items-center space-y-4">
            <div className="w-full flex flex-row justify-between items-center space-x-4">
              <motion.span
                initial={{ x: '-100vw' }}
                animate={{ x: 0 }}
                transition={{ stiffness: 100, delay: 1, type: 'slide' }}
                className="w-[40%] min-h-[450px] justify-start p-8 max-lg:p-4 border border-solid border-black black-gradient shadow shadow-white/50 rounded-3xl flex flex-col"
              >
                <span className="text-white text-4xl text-left pt-4 pb-2 w-[60%] max-lg:w-[80%] font-semibold">
                  Built for stories
                </span>
                <span className="text-white/80 leading-6 text-lg text-left pb-4 w-[70%] max-lg:w-[90%]">
                  Our hardware is designed for high quality speaker output
                </span>
                <span className="text-white text-2xl text-left pt-2 pb-10 font-semibold">
                  Max volume: ~100dB
                </span>
                <img
                  src={
                    'https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1723729319/pixa-pie/features/music_feature.webp'
                  }
                  alt="music"
                  className="w-full object-contain object-center"
                ></img>
              </motion.span>
              <motion.div
                initial={{ x: '100vw' }}
                animate={{ x: 0 }}
                transition={{ stiffness: 100, delay: 1, type: 'slide' }}
                className="w-[60%] min-h-[450px] justify-center items-center border border-solid border-black shadow-lam shadow-white rounded-3xl bg-lam-pattern bg-no-repeat bg-cover bg-center flex flex-col"
              >
                <span className="pb-4 mt-2 text-white text-2xl">
                  Powered by
                </span>
                <span
                  className={`${styles.goldenText} text-9xl max-lg:text-8xl w-[70%] font-bold`}
                >
                  AI
                </span>
                <span className="w-[80%] mt-8 space-x-6 flex flex-row justify-center items-center text-center">
                  <span className="bg-timer-pattern bg-contain bg-no-repeat bg-center h-[52px] w-[52px]"></span>
                  <span className="bg-msg-pattern bg-contain bg-no-repeat bg-center h-[52px] w-[52px]"></span>
                  <span className="bg-music-pattern bg-contain bg-no-repeat bg-center h-[52px] w-[52px]"></span>
                </span>
              </motion.div>
            </div>
            <div className="w-full flex flex-row items-center space-x-4 justify-between">
              <motion.div
                initial={{ x: '-100vw' }}
                animate={{ x: 0 }}
                transition={{ stiffness: 100, delay: 1, type: 'slide' }}
                className="w-[50%] justify-center items-center min-h-48 border border-solid border-black black-gradient shadow shadow-white/50 rounded-3xl flex flex-col p-4"
              >
                <span className="bg-shield-pattern w-full h-[100px] max-lg:mt-0 bg-contain bg-no-repeat bg-center"></span>
                <span className="text-white text-3xl max-lg:text-xl text-center pt-2 pb-2 font-semibold">
                  Privacy focused
                </span>
              </motion.div>
              <motion.div
                initial={{ x: '100vw' }}
                animate={{ x: 0 }}
                transition={{ stiffness: 100, delay: 1, type: 'slide' }}
                className="w-[50%] justify-center items-center min-h-48 border border-solid border-black black-gradient shadow shadow-white rounded-3xl text-white flex flex-col text-center p-4"
              >
                <span className="w-[90%] text-4xl font-semibold">
                  A true companion for everyone
                </span>
              </motion.div>
            </div>
            <motion.div
              initial={{ y: '100vh' }}
              animate={{ y: 0 }}
              transition={{ stiffness: 100, delay: 1, type: 'slide' }}
              className="w-full py-8 justify-evenly items-center border border-solid border-black black-gradient shadow shadow-white/70 rounded-3xl flex flex-col text-center"
            >
              <span className="flex flex-row justify-center items-center w-[90%]">
                <span className="rounded-full h-40 bg-cover bg-no-repeat bg-center bg-person-1-pattern w-40"></span>
                <span className="rounded-full h-40 bg-cover bg-no-repeat bg-center bg-person-2-pattern w-40 -ml-8"></span>
                <span className="rounded-full h-40 bg-cover bg-no-repeat bg-center bg-person-3-pattern w-40 -ml-8"></span>
              </span>
              <span className="flex flex-col text-center justify-center items-center space-x-3 mt-4 w-[80%]">
                <span className="text-white font-semibold text-5xl mt-4 mb-2">
                  Loved by kids
                </span>
                <span className="text-white font-semibold text-5xl mb-4 mt-2">
                  and parents
                </span>
              </span>
            </motion.div>
            <div className="w-full flex flex-row items-center space-x-4 justify-between">
              <motion.div
                initial={{ x: '-100vw' }}
                animate={{ x: 0 }}
                transition={{ stiffness: 100, delay: 1, type: 'slide' }}
                className="w-[50%] justify-center items-center min-h-48 border border-solid border-black black-gradient shadow shadow-white/70 rounded-3xl flex flex-col"
              >
                <span className="flex flex-row justify-center items-center w-[90%] mb-3">
                  <span className="text-white text-3xl font-semibold">
                    Up to
                  </span>
                  <span className="bg-battery-pattern bg-contain bg-no-repeat bg-center h-12 w-[48%]"></span>
                </span>
                <span className="text-white text-3xl font-semibold w-full flex justify-center items-center text-center">
                  battery everyone
                </span>
              </motion.div>
              <motion.div
                initial={{ x: '100vw' }}
                animate={{ x: 0 }}
                transition={{ stiffness: 100, delay: 1, type: 'slide' }}
                className="w-[50%] justify-center items-center min-h-48 border border-solid border-black black-gradient shadow shadow-white/70 rounded-3xl flex flex-col"
              >
                <span
                  className={`${styles.goldenText} font-bold text-5xl max-lg:text-4xl`}
                >
                  Wifi
                </span>
                <span
                  className={`text-white font-semibold text-4xl max-lg:text-3xl`}
                >
                  Connectivity
                </span>
              </motion.div>
            </div>
          </div>
          {/* for sm screen */}
          <div className="only-show-on-mobile-screen w-[90%] min-h-screen flex flex-col justify-center items-center space-y-4">
            <div className="flex flex-col justify-around items-center space-y-4">
              <motion.div
                initial={{ x: '-100vw' }}
                animate={{ x: 0 }}
                transition={{ stiffness: 100, delay: 1, type: 'slide' }}
                className="w-full justify-start p-4 px-8 border border-solid border-black black-gradient shadow shadow-white/50 rounded-3xl flex flex-col"
              >
                <span className="text-white text-[28px] leading-[32px] text-left pt-4 pb-2 w-full font-semibold">
                  Built for stories
                </span>
                <span className="text-white/80 leading-6 text-[16px] text-left pb-4 w-full">
                  Our hardware is designed for high quality speaker output
                </span>
                <span className="text-white text-xl text-left pt-2 pb-4 font-semibold">
                  Max volume: ~100dB
                </span>
                <span className="bg-voice-pattern w-full h-[100px] mt-[-16px] bg-contain bg-no-repeat bg-center"></span>
              </motion.div>
              {/* <motion.div
                initial={{ x: '100vw' }}
                animate={{ x: 0 }}
                transition={{ stiffness: 100, delay: 1, type: 'slide' }}
                className="w-[95%] justify-center items-center h-[30%] border border-solid border-black black-gradient shadow shadow-white/50 rounded-3xl flex flex-col p-2 py-6"
              >
                <span className="bg-shield-pattern w-full h-[80px] bg-contain bg-no-repeat bg-center"></span>
                <span className="text-white text-[28px] text-center pt-2 font-semibold">
                  Privacy focused
                </span>
              </motion.div> */}
            </div>
            <div className="flex flex-col justify-around items-center space-y-4 w-full">
              <motion.div
                initial={{ x: '-100vw' }}
                animate={{ x: 0 }}
                transition={{ stiffness: 100, delay: 1, type: 'slide' }}
                className="w-full justify-center items-center border border-solid border-black shadow-lam shadow-white rounded-3xl bg-lam-pattern bg-no-repeat bg-cover bg-center flex flex-col p-4 py-8"
              >
                <span className="pb-4 text-white text-xl">Powered by</span>
                <span
                  className={`${styles.goldenText} text-9xl leading-none  w-[80%] font-bold`}
                >
                  AI
                </span>
                <span className="w-[80%] mt-8 space-x-6 flex flex-row justify-center items-center text-center">
                  <span className="bg-timer-pattern bg-contain bg-no-repeat bg-center h-[36px] w-[36px]"></span>
                  <span className="bg-msg-pattern bg-contain bg-no-repeat bg-center h-[36px] w-[36px]"></span>
                  <span className="bg-music-pattern bg-contain bg-no-repeat bg-center h-[36px] w-[36px]"></span>
                </span>
              </motion.div>
              {/* <motion.div
                initial={{ x: '100vw' }}
                animate={{ x: 0 }}
                transition={{ stiffness: 100, delay: 1, type: 'slide' }}
                className="w-[95%] lam-width justify-center items-center h-[35%] border border-solid border-black black-gradient shadow shadow-white rounded-3xl text-white flex flex-col text-center px-2 py-8"
              >
                <span className="w-[100%] px-[24px] text-[1.6rem] font-semibold">
                  A true companion for everyone
                </span>
              </motion.div> */}
            </div>
            <div className="w-full flex flex-col justify-around items-center space-y-4">
              {/* <motion.div
                initial={{ x: '-100vw' }}
                animate={{ x: 0 }}
                transition={{ stiffness: 100, delay: 1, type: 'slide' }}
                className="w-[95%] justify-evenly items-center h-[36%] border border-solid border-black black-gradient shadow shadow-white/70 rounded-3xl flex flex-col text-center p-4 space-y-2 py-8"
              >
                <span className="flex flex-row justify-center items-center w-[80%]">
                  <span className="rounded-full h-20 bg-cover bg-no-repeat bg-center bg-person-1-pattern w-20"></span>
                  <span className="rounded-full h-20 bg-cover bg-no-repeat bg-center bg-person-2-pattern w-20 -ml-4"></span>
                  <span className="rounded-full h-20 bg-cover bg-no-repeat bg-center bg-person-3-pattern w-20 -ml-4"></span>
                </span>
                <span className="flex flex-col text-center justify-center items-center space-x-1 w-[80%]">
                   <span className="text-white font-semibold text-2xl">
                    Loved by kids
                  </span>
                  <span className="text-white font-semibold text-2xl">
                    and parents
                  </span>
                </span>
              </motion.div> */}
              <motion.div
                initial={{ x: '100vw' }}
                animate={{ x: 0 }}
                transition={{ stiffness: 100, delay: 1, type: 'slide' }}
                className="w-full justify-center items-center border border-solid border-black black-gradient shadow shadow-white/70 rounded-3xl flex flex-col p-4 py-8"
              >
                <span className="flex flex-row justify-center items-center w-[90%] mb-3">
                  <span className="text-white text-3xl font-semibold">
                    Up to
                  </span>
                  <span className="bg-battery-pattern bg-contain bg-no-repeat bg-center h-10 w-[48%]"></span>
                </span>
                <span className="text-white text-3xl font-semibold w-full flex  justify-center items-center text-center">
                  battery everyone
                </span>
              </motion.div>
              {/* <motion.div
                initial={{ x: '-100vw' }}
                animate={{ x: 0 }}
                transition={{ stiffness: 100, delay: 1, type: 'slide' }}
                className="w-[95%] justify-center items-center h-[25%] border border-solid border-black black-gradient shadow shadow-white/70 rounded-3xl flex flex-col p-4 py-8"
              >
                <span className={`${styles.goldenText} font-semibold text-5xl`}>
                  Wifi
                </span>
                <span className={`text-white font-semibold text-4xl`}>
                  Connectivity
                </span>
              </motion.div> */}
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );
}

export default Videofeatures;
